import { VueQueryPlugin } from '@tanstack/vue-query'
import {
  Alert,
  Affix,
  AutoComplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Collapse,
  DatePicker,
  Divider,
  Dropdown,
  Drawer,
  Empty,
  Form,
  FloatButton,
  Flex,
  Image,
  Menu,
  Modal,
  Pagination,
  Popover,
  Popconfirm,
  Progress,
  Radio,
  Segmented,
  Select,
  Skeleton,
  Slider,
  Spin,
  Switch,
  Steps,
  Tag,
  Timeline,
  Tooltip,
  Tree,
  Typography,
  ConfigProvider,
  Input,
  InputNumber,
  Table,
  Tabs,
  Tour,
  Upload,
} from 'ant-design-vue'

import 'ant-design-vue/dist/reset.css'
import 'virtual:uno.css'
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm'
import {
  Chart,
  BarController,
  BarElement,
  DoughnutController,
  ArcElement,
  ScatterController,
  LineController,
  PointElement,
  LineElement,
  LinearScale,
  CategoryScale,
  TimeScale,
  Tooltip as ChartJSTooltip,
} from 'chart.js'
import { SankeyController, Flow } from 'chartjs-chart-sankey'
import annotationPlugin from 'chartjs-plugin-annotation'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { createPinia } from 'pinia'
import { LogArgument } from 'rollbar'
import { createApp } from 'vue'
// import {
//   BoxPlotController,
//   BoxAndWiskers
// } from '@sgratzl/chartjs-chart-boxplot'
import useQueryParamPlugin from 'vue-use-query-param'

import { getEnvFromUrl } from '@/utilities/env'

import App from './App.vue'
import { router } from './router/router'
import { queryClient } from './services/queryClient'
import { rollbar, ignoredRollbarErrors } from './utilities/rollbar'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

app.use(VueQueryPlugin, { queryClient })

app.use(Alert)
app.use(Affix)
app.use(Avatar)
app.use(AutoComplete)
app.use(Badge)
app.use(Breadcrumb)
app.use(Button)
app.use(Card)
app.use(Checkbox)
app.use(ConfigProvider)
app.use(Collapse)
app.use(DatePicker)
app.use(Divider)
app.use(Drawer)
app.use(Dropdown)
app.use(Empty)
app.use(FloatButton)
app.use(Form)
app.use(Flex)
app.use(Image)
app.use(Input)
app.use(InputNumber)
app.use(Modal)
app.use(Menu)
app.use(Pagination)
app.use(Popconfirm)
app.use(Popover)
app.use(Progress)
app.use(Radio)
app.use(Segmented)
app.use(Select)
app.use(Slider)
app.use(Skeleton)
app.use(Spin)
app.use(Switch)
app.use(Steps)
app.use(Timeline)
app.use(Tooltip)
app.use(Tag)
app.use(Table)
app.use(Tabs)
app.use(Tour)
app.use(Tree)
app.use(Typography)
app.use(Upload)

app.use(router)
app.use(useQueryParamPlugin, {})

Chart.register(
  BarController,
  BarElement,
  LineController,
  LinearScale,
  CategoryScale,
  TimeScale,
  PointElement,
  LineElement,
  DoughnutController,
  ArcElement,
  ChartJSTooltip,
  ScatterController,
)
Chart.register(ChartDataLabels)
Chart.register(SankeyController, Flow)
// Chart.register(BoxPlotController, BoxAndWiskers)
Chart.register(annotationPlugin)

Chart.defaults.font.family = 'Inter'
Chart.defaults.font.size = 13

Chart.defaults.plugins.tooltip.backgroundColor = 'rgba(0, 0, 0, 0.9)'
Chart.defaults.plugins.tooltip.padding = { left: 12, right: 12, top: 12, bottom: 12 }
Chart.defaults.plugins.tooltip.boxPadding = 6
Chart.defaults.plugins.tooltip.titleFont = {
  weight: 500,
  size: 14,
}
Chart.defaults.plugins.tooltip.bodyFont = {
  size: 14,
}

// @ts-expect-error ChartJS typings
Chart.defaults.plugins.datalabels.display = false

app.mount('#app')

const ENV = getEnvFromUrl()

app.config.errorHandler = (err, instance, info) => {
  const ignoredError =
    (typeof err === 'string' && ignoredRollbarErrors.some((e) => err.includes(e))) ||
    (err instanceof Error &&
      ignoredRollbarErrors.some(
        (e) => err.name.includes(e) || err.message.includes(e) || err.stack?.includes(e),
      ))

  if (ENV !== 'local' && !ignoredError) {
    rollbar.error(err as LogArgument, { info, instance })
  }
  console.error(err, instance, info)
}
